module.exports = __webpack_public_path__ + "img/pic1-0.a2346433.png";